export enum DialogHandlerDefaultDialogCustomPositionChoice {
  ENABLED = 1,
  DISABLED = 0,
}